import { RootState } from "./Account";
import { useSelector } from "react-redux";
import { wishlist } from "../../data/account/allcourse";

const Wishlist = () => {
  const data = wishlist.map((course, i) => (
    <div key={i}>
      <img
        src={course.banner}
        width="91"
        height="81"
        alt="course"
      />
      <div>
        <h4>{course.title}</h4>
        <div className="wishlist-det">
          <p style={{ color: "var(--vidomGray)", fontSize: "0.75em" }}>
            {course.duration}
          </p>
          <p
            style={{
              color: "var(--vidomSecondaryBlack)",
              fontSize: "0.875em",
              fontWeight: 700,
            }}
          >
            {course.price}
          </p>
        </div>
      </div>
    </div>
  ));

  const checkTop = useSelector((state: RootState) => state.top.top);

  return (
    <section
      className="wishlist-acct"
      style={checkTop}
    >
      {data}
    </section>
  );
};

export default Wishlist;
